<template>
  <div
    class="Overlay Overlay-sup"
    data-action="close-modal"

  >
    <div class="ModalBox ModalBox--central ModalBox--20vw Modal--filters sup2">
      <div class="
          ModalBox-header
          d-flex
          justify-content-between
          align-items-center
          position-absolute
          p-3
        ">
        <div class="Tit Tit--modal position-absolute w-100">
          {{$t('customers_users_request_card_action')}}
        </div>
        <div
          class="Ctrl Ctrl--24 u-pointer"
          data-action="close-modal"
          @click="closeModal"
        >
          <svg
            focusable="false"
            aria-hidden="true"
            aria-label="Close"
          >
            <use xlink:href="#close-icon" />
          </svg>
        </div>
      </div>
      <div class="ModalBox-container position-relative pl-4 pr-4 pt-4 mt-5 pb-3">
        <i18n
          tag="p"
          class="Fuell-Text"
          path="customers_users_request_card_info"
          v-if="!sendCardToOffice"
        >
          <template v-slot:userName>
            <span class="text-primary">{{user.firstName}} {{user.lastName}}</span>
          </template>
        </i18n>
        <i18n tag="p" class="Fuell-Text pb-2 w-100" path="customers_users_request_card_no_sending_info" v-else>
          <template v-slot:userName>
            <span class="text-primary">{{user.firstName}} {{user.lastName}}</span>
          </template>
        </i18n>
          <form
            @submit.prevent="handleConfirm"
            id="request-card-form"
          >
        <template v-if="!sendCardToOffice">
            <div class="input--block input--block--margin input--block--padded">
              <label
                for=""
                class="form--label u-required"
              > {{$t('ADDRESS').toUpperCase()}}</label>
              <div
                class="Form-field"
                :class="{'input--error' : $v.shippingAddress.address.$error}"
              >
                <input
                  class="Input-text"
                  type="text"
                  v-model.trim="shippingAddress.address"
                  :placeholder="$t('ADDRESS_PLACEHOLDER')"
                  @blur="$v.shippingAddress.address.$touch()"
                />
              </div>
            </div>
            <div class="input--block input--block--margin input--block--padded">
              <label
                for=""
                class="form--label u-required"
              > {{$t('CITY').toUpperCase()}}</label>
              <div
                class="Form-field"
                :class="{'input--error' : $v.shippingAddress.city.$error}"
              >
                <input
                  class="Input-text"
                  type="text"
                  v-model.trim="shippingAddress.city"
                  @blur="$v.shippingAddress.city.$touch()"
                  :placeholder="$t('CITY')"
                />
              </div>
            </div>
            <div class="input--block input--block--margin input--block--padded">
              <label
                for=""
                class="form--label u-required"
              >{{$t('STATE').toUpperCase()}}</label>
              <div
                class="Form-field"
                :class="{'input--error' : $v.shippingAddress.state.$error}"
              >
                <input
                  class="Input-text"
                  type="text"
                  v-model.trim="shippingAddress.state"
                  @blur="$v.shippingAddress.state.$touch()"
                  :placeholder="$t('STATE')"
                />
              </div>
            </div>
            <div class="input--block input--block--margin input--block--padded">
              <label
                for=""
                class="form--label u-required"
              >{{$t('ZIP').toUpperCase()}}</label>
              <div
                class="Form-field"
                :class="{'input--error' :$v.shippingAddress.zipCode.$error}"
              >
                <input
                  class="Input-text"
                  v-model.trim="shippingAddress.zipCode"
                  :placeholder="$t('ZIP')"
                  @blur="$v.shippingAddress.zipCode.$touch()"
                  type="text"
                />
              </div>
            </div>
            <div class="input--block input--block--margin input--block--padded">
              <label
                for=""
                class="form--label"
              >{{$t('COUNTRY').toUpperCase()}}</label>
              <div
                class="Form-field"
                :class="{'input--error' : $v.shippingAddress.country.$error}"
              >
                <input-select
                  :dataCollection="countries"
                  :placeholder="'COUNTRY'"
                  :defaultSelected="'ES'"
                  :fieldForDefaultSelected="'isoCode'"
                  ignoreItemTranslation
                  @input="setCountry($event)"
                />
              </div>
            </div>
        </template>
            <div class="d-flex w-100 justify-content-center">
              <button
                v-if="!isRequestingCardFlag"
                type="submit"
                :disabled="disableRequestCardButton"
                :class="{ 'disabled': disableRequestCardButton }"
                form="request-card-form"
                class="Fuell-Button block blue  w-50 mt-2"
              >
                {{$t('customers_users_request_card_action')}}
              </button>

              <template v-else>

                <spinner />

              </template>
            </div>
          </form>
      </div>
    </div>
    <confirm-modal
      :message="''"
      :open.sync="showConfirmModalFlag"
      v-if="showConfirmModalFlag"
      ignoreDefaultMessage
      @accept="requestCard"
      :title="'customers_users_request_card_action'"
      :acceptText="'customers_users_request_card_action'"
      :dismissText="'ACTION_CANCEL'"
    >
      <template v-slot:additional>
        <i18n
          tag="p"
          class="Fuell-Text"
          path="customers_users_request_card_summary_info"
        >
          <template v-slot:userName><span class="text-primary"> {{user.firstName}} {{user.lastName}}</span></template>
          <template v-slot:verify><span class="text-danger u-bold">{{$t('customers_users_request_card_summary_info_verify')}}</span></template>
        </i18n>
        <div class="content d-flex justify-content-center flex-column mx-auto Fuell-Text">
          <div class="d-flex justify-content-between w-100">
            <span class="Fuell-Text u-bold">{{$t('USER')}}: </span>
            <span class="Fuell-Text">{{user.firstName}} {{user.lastName}}</span>
          </div>

          <div class="d-flex justify-content-between">
            <span class="Fuell-Text u-bold"> {{$t('ADDRESS')}}:</span>
            <span class="Fuell-Text">{{shippingAddress.address}}</span>

          </div>
          <div class="d-flex justify-content-between">

            <span class="Fuell-Text u-bold">{{$t('CITY')}}:</span>
            <span class="Fuell-Text">{{shippingAddress.city}}</span>
          </div>
          <div class="d-flex justify-content-between">
            <span class="Fuell-Text u-bold"> {{$t('STATE')}}:</span>
            <span class="Fuell-Text">{{shippingAddress.state}}</span>

          </div>
          <div class="d-flex justify-content-between">
            <span class="Fuell-Text u-bold"> {{$t('ZIP')}}:</span>
            <span class="Fuell-Text">{{shippingAddress.zipCode}}</span>

          </div>
          <div class="d-flex justify-content-between">
            <span class="Fuell-Text u-bold">{{$t('COUNTRY')}}:</span>
            <span class="Fuell-Text">{{shippingAddress.country.name}}</span>

          </div>
        </div>
      </template>

    </confirm-modal>
  </div>
</template>

<script>
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import cardsApi from '@/modules/cards/_api'
import InputSelect from '@/components/Commons/Forms/InputSelect'
import Spinner from '@/components/Commons/Spinner'

import { CARD_EMISSION_TYPE } from '@/modules/customers/_constants/constants'
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')
const { validationMixin } = require('vuelidate')
const { required } = require('vuelidate/lib/validators')

export default {
  name: 'SuperAdminCreateCardModal',
  mixins: [_modalHandlerMixin, validationMixin],
  components: { InputSelect, Spinner, ConfirmModal },
  props: {
    user: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      shippingAddress: {
        address: '',
        zipCode: '',
        city: '',
        state: '',
        country: { id: 1 },
        id: null
      },
      isRequestingCardFlag: false,
      showConfirmModalFlag: false
    }
  },
  computed: {
    countries () {
      return this.$store.getters['ConfigStore/publicConfig'].countries.filter(
        (el) => el.shippingAddressEnabled
      )
    },
    sendCardToOffice () {
      return this.user?.office?.sendCardToOffice
    },
    disableRequestCardButton () {
      if (this.sendCardToOffice) {
        return this.isRequestingCardFlag
      } else {
        return this.isRequestingCardFlag || this.$v.$invalid
      }
    }
  },
  methods: {
    async handleConfirm () {
      if (!this.sendCardToOffice) {
        this.showConfirmModalFlag = true
      } else {
        await this.requestCard()
      }
    },
    async requestCard () {
      if (this.isRequestingCardFlag) return
      try {
        this.showConfirmModalFlag = false
        this.isRequestingCardFlag = true

        let cardData = {
          user: {
            id: this.user.id,
          typeOfCardWhenRegisteredOnIssuer: CARD_EMISSION_TYPE.PHYSICAL
          }
        }
        if (!this.sendCardToOffice) {
          cardData.user['shippingAddress'] = {
            ...this.shippingAddress
          }
          if (this.user.shippingAddress?.id) {
            cardData.user['shippingAddress']['id'] = this.user.shippingAddress.id
          }
        }

        await cardsApi.postPhysicalCardSuperadmin(cardData)
        this.$emit('updateCards')
        this.$store.dispatch(
          'SnackBars/addSuccess',
          this.$i18n.t('customers_users_request_card_success'),
          { root: true }
        )

        this.closeModal()
      } catch (error) {
        this.$store.dispatch(
          'SnackBars/addErrorHandler',
          { error: error, errorMessage: 'customers_users_request_card_error' },
          { root: true }
        )
      } finally {
        this.isRequestingCardFlag = false
      }
    },
    setCountry (event) {
      if (event?.target?.value) {
        let { name } = this.countries.find(el => el.id === Number.parseInt(event.target.value))
        this.shippingAddress.country = { id: event.target.value, name: name }
      } else {
        this.shippingAddress.country = { id: event.id, name: event.name }
      }
      this.$v.shippingAddress.country.$touch()
    },
    _initializeShippingAddress () {
      const { shippingAddress } = this.user
      this.shippingAddress = { ...shippingAddress }
    }
  },
  created () {
    this._initializeShippingAddress()
  },
  validations: {
    shippingAddress: {
      address: { required },
      zipCode: { required },
      city: { required },
      state: { required },
      country: { required }
    }
  }
}
</script>

<style scoped>
.content {
  max-width: 75%;
}
.u-bold {
  font-weight: 600;
}
</style>
